export default "__VITE_ASSET__Dx0as7Rn__"